import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';

const FullNameTextField = (props) => {
    const {
        data,
        record,
    } = props;

    // In some cases we use the record property and others the data.
    const value = data || record;

    if (utils.isEmpty(value)) {
        return null;
    }

    function showFullName(item) {
        const {
            first_name,
            last_name,
        } = item;

        return utils.fullName(first_name, last_name);
    }

    return <span>{ showFullName(value) }</span>;
};

FullNameTextField.propTypes = {
    data: PropTypes.object,
    record: PropTypes.object,
};

export default FullNameTextField;



// WEBPACK FOOTER //
// ./src/components/field/FullNameField.js